import { cn } from '../../lib/utils';

function formatDigits(digits: string): string {
  const parts = [digits.slice(0, 2), digits.slice(2, 5), digits.slice(5, 7), digits.slice(7, 9)];
  return parts.filter(Boolean).join(' ');
}

export function PhoneInput({
  value,
  onChange,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  const digits = value.startsWith('+380') ? value.slice(4) : '';

  return (
    <div
      className={cn(
        'flex items-stretch border border-line bg-surface transition-colors duration-140',
        'focus-within:border-accent',
        className,
      )}
    >
      <span className="flex items-center gap-2 border-r border-line px-4 text-[15px] text-ink">
        <span aria-hidden className="text-[22px] leading-none">
          🇺🇦
        </span>
        +380
      </span>
      <input
        type="tel"
        inputMode="numeric"
        placeholder="XX XXX XX XX"
        value={formatDigits(digits)}
        onChange={(e) => {
          const raw = e.target.value.replace(/\D/g, '').slice(0, 9);
          onChange(raw ? `+380${raw}` : '');
        }}
        className="w-full bg-transparent px-4 py-3 text-[15px] text-ink outline-none placeholder:text-muted-2"
      />
    </div>
  );
}
